import { ReactNode } from 'react'
import { StyleBg } from './style'

interface IStatus {
  status?: string
  children?: ReactNode
}

const Status = ({ status, children }: IStatus) => {
  let bg = ''
  let tc = ''

  switch (status) {
    case 'Pending':
      bg = 'red200'
      tc = 'red800'
      break
    case 'Driver Assigned':
      bg = 'primary50'
      tc = 'primary'
      break
    case 'Book Lent':
      bg = 'green400'
      tc = 'green600'
      break
    case 'Book Returned':
      bg = 'yellowLight'
      tc = 'yellowNormal'
      break
    case 'Book Borrowed':
      bg = 'green400'
      tc = 'green600'
      break
    case 'UnSubscribed':
      bg = 'red200'
      tc = 'red800'
      break
    case 'Subscribed':
      bg = 'green200'
      tc = 'green500'
      break

      bg = 'green200'
      tc = 'green500'
      break
    default:
      bg = 'primary50'
      tc = 'primary'
  }

  return (
    <StyleBg bg={bg} tc={tc}>
      {status || children}
    </StyleBg>
  )
}

export default Status
